import React from 'react';
import styled from 'styled-components';
import { useDarkMode } from 'context/DarkModeContext';

const ThemeScope = styled.div`
  ${({ $dark }) =>
    $dark
      ? ''
      : `
    --admincat-color-grey-0: #ffffff;
    --admincat-color-grey-1: #ffffff;
    --admincat-color-grey-2: #000000;
    --admincat-color-grey-3: #68696a;
    --admincat-color-grey-4: #f5f7fb;
    --admincat-color-grey-5: #e1e3e8;
    --admincat-color-grey-6: #eaedf1;
    --admincat-color-grey-7: #626467;
    --admincat-color-grey-8: #bbbbbb;
    --admincat-color-grey-9: #e0e5ec;
    --admincat-color-grey-10: #AEABAB;
    --admincat-color-grey-11: #777777;
    --admincat-color-grey-12: #2c2d2f;
    --admincat-color-grey-13: #e7eff3;
    --admincat-color-grey-14: #e1e3e8;
    --admincat-color-grey-15: #9fa7b0;
    --admincat-color-grey-16: #DBDEE3;
    --admincat-color-grey-17: #495057;
    --admincat-color-grey-18: #68696A;
    --admincat-color-grey-19: #DBDEE3;
    --admincat-color-grey-20: #0000001A;
    --admincat-color-grey-21: rgb(214, 215, 216);
    --admincat-color-grey-22: #a7acad;
  `}
`;

export const useEffectiveDark = (isAuth) => {
  const { isDarkMode } = useDarkMode();
  return Boolean(isDarkMode && isAuth);
};

export const AuthGatedTheme = ({ isAuth, children }) => {
  const isDark = useEffectiveDark(isAuth);
  return <ThemeScope $dark={isDark}>{children}</ThemeScope>;
};


